import React from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { ButtonWrapper } from '../../components';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <div className="row">
        <div className="Node NotFound col-12 col-lg-8 offset-lg-2">
          <h1>{t('pages.404.title')}</h1>
          <p>{t('pages.404.body')}</p>
          <ButtonWrapper href={t('pages.404.primary_button.url')}>{t('pages.404.primary_button.link')}</ButtonWrapper>
        </div>
      </div>
    </Container>
  );
};

export default NotFound;
